import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';

@Component({
  selector: 'hour4u-admin-edit-outcome-popup',
  templateUrl: './edit-outcome-popup.component.html',
  styleUrls: ['./edit-outcome-popup.component.scss']
})
export class EditOutcomePopupComponent implements OnInit {
  clientName = '';
  currentStatus = '';
  aiOutcome = '';
  selectedOutcome = '';
  humanComment = '';
  outcomeOptions: string[] = [];
  humanReviewedBy = '';
  humanReviewedAtLabel = '';
  lastHumanRemark = '';
  hasExistingHumanReview = false;
  isLoading = false;
  profile: any;

  constructor(
    private dialogRef: MatDialogRef<EditOutcomePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notify: NotificationService,
    private jobService: JobService,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.profile = this.appService.getCurrentAccount();
    const call = this.data && this.data.call;
    this.clientName = (call && call.client_name) || 'Lead';
    this.currentStatus = (call && call.status) || '';
    this.aiOutcome = (call && call.ai_outcome) || '';
    this.selectedOutcome = this.currentStatus;
    this.humanComment = (call && call.human_comment) || '';
    this.humanReviewedBy = (call && call.human_reviewed_by) || '';
    this.humanReviewedAtLabel = this.formatHumanReviewAt(call);
    this.lastHumanRemark = this.humanComment;
    this.hasExistingHumanReview = this.isHumanReviewed(call);

    const fromProject = (this.data && this.data.expectedOutcomes || [])
      .map((o: any) => (o && o.outcome_name) ? String(o.outcome_name).trim() : '')
      .filter(Boolean);

    const merged = [...fromProject];
    if (this.currentStatus && !merged.includes(this.currentStatus)) {
      merged.unshift(this.currentStatus);
    }
    this.outcomeOptions = merged;
  }

  private isHumanReviewed(call: any): boolean {
    if (!call) {
      return false;
    }
    return call.reviewed_by_human === true
      || call.reviewed_by_human === 'true'
      || !!(call.human_reviewed_by || call.human_comment);
  }

  private formatHumanReviewAt(call: any): string {
    const raw = call && call.human_reviewed_at;
    if (raw == null || raw === '') {
      return '';
    }
    const seconds = typeof raw === 'number' ? raw : Number(String(raw).trim());
    if (!Number.isFinite(seconds) || seconds <= 0) {
      return '';
    }
    const date = new Date(seconds < 1e12 ? seconds * 1000 : seconds);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  closeDialog(saved = false) {
    this.dialogRef.close(saved);
  }

  saveOutcome() {
    const call = this.data && this.data.call;
    const entityId = this.profile && this.profile.entity && this.profile.entity.id;
    const projectId = (call && call.project_id) || (this.data && this.data.projectId);
    const peopleId = call && call.people_id;
    const jobId = call && call.job_id;

    if (!entityId || !projectId || !peopleId || !jobId) {
      this.notify.showMessage('Missing lead or session information', 3000);
      return;
    }

    const outcome = (this.selectedOutcome || '').trim();
    if (!outcome) {
      this.notify.showMessage('Please select an outcome', 3000);
      return;
    }

    const outcomeChanged = outcome !== (this.currentStatus || '').trim();

    this.isLoading = true;
    this.jobService.updateJobsStatusHumanReview(entityId, {
      projectId,
      peopleId,
      jobId,
      reviewedByHuman: true,
      outcome,
      humanComment: (this.humanComment || '').trim(),
      disableExistingTask: outcomeChanged
    }).subscribe(
      () => {
        this.isLoading = false;
        this.notify.showMessage('Outcome updated', 3000);
        this.closeDialog(true);
      },
      (err) => {
        this.isLoading = false;
        const msg =
          (err && err.error && err.error.error) ||
          (err && err.error && err.error.message) ||
          'Failed to update outcome';
        this.notify.showMessage(msg, 5000);
      }
    );
  }
}
